import { CommonModule, NgStyle } from '@angular/common';
import { Component, EventEmitter, Output, signal } from '@angular/core';

@Component({
  selector: 'pull-to-refresh',
  imports: [CommonModule, NgStyle],
  standalone: true,
  styleUrl: './pull-to-refresh.component.css',
  templateUrl: './pull-to-refresh.component.html',
})
export class PullToRefreshComponent {
  @Output() refresh = new EventEmitter<void>();

  pulling = signal(false);
  pullDistance = signal(0);

  private startY = 0;
  public threshold = 60; // pixels

  onTouchStart(event: TouchEvent) {
    const container = event.currentTarget as HTMLElement;
    if (container && container.scrollTop === 0) {
      this.startY = event.touches[0].clientY;
      this.pulling.set(true);
    }
  }

  onTouchMove(event: TouchEvent) {
    if (!this.pulling()) return;

    const currentY = event.touches[0].clientY;
    const distance = currentY - this.startY;

    if (distance > 0) {
      this.pullDistance.set(Math.min(distance, 100));
    } else {
      this.pullDistance.set(0);
    }
  }

  onTouchEnd() {
    if (!this.pulling()) return;

    if (this.pullDistance() > this.threshold) {
      this.refresh.emit();
    }

    this.pullDistance.set(0);
    this.pulling.set(false);
  }
}
